import { factory, Flex, AspectRatioKeeper, Image, Typography, DsmColor, omitText } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import classes from './ProductItem.module.css.mjs';

const ProductItem = factory((props, ref) => {
  const { title, image, className, component = "a", ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      component: rest.href ? component : "div",
      ref,
      ...rest,
      direction: "column",
      gap: "15px",
      align: "center",
      borderRadius: "1px",
      className: clsx("kohler-product-item-root", classes.productListHeroProduct, className)
    },
    /* @__PURE__ */ React.createElement(AspectRatioKeeper, { aspectRatio: "1:1" }, /* @__PURE__ */ React.createElement(Image, { ...image })),
    /* @__PURE__ */ React.createElement(Typography, { component: title.component || "h2", ...omitText(title), size: "label-regular-m", textColor: DsmColor.ContentPrimary }, title.text)
  );
});

export { ProductItem };
